/**
 * This logic written specifically for Radar device types
 * Radar currently can be configured only using Synthetic APIs
 * See more here: https://github.com/peoplepower/peoplepower-docs/blob/master/synthetic_apis/radar.md#set-the-room-boundaries
 */

import SubregionsTemplate from './subregions.html';

export default angular
  .module('main.devices.edit.tabs.subregions', [])

  .directive('editDeviceSubregionsTab', ($filter) => {
    const $t = $filter('translate');
    return {
      restrict: 'E',
      template: SubregionsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   utils,
                   ToastsService,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;
        $scope.editable = false;

        angular.extend($scope, {
          onAddButtonClick: onAddButtonClick,
          editSubregion: editSubregion,
          selectSubregion: selectSubregion,
          removeSubregion: removeSubregion,
          getSubregionContext: getSubregionContext,
          gotoRoomBoundaries: gotoRoomBoundaries,
        });

        init();

        // Remove modals
        $scope.$on('$destroy', () => {
          $('#remove-subregion-dialog').remove();
        });

        function init() {
          $scope.loading = true;
          return $q.all([
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.botDrivenRegionsResource.init(),
            $scope.dataProvider.locationStateRegionBehaviorsResource.init(),
            $scope.dataProvider.locationStateBoundariesResource.init(),
            $scope.dataProvider.locationStateRegionsResource.init(),
          ])
            .then(() => {
              initWatchers();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              $scope.editable = false;
              // utils.handleApiError(err);
            });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'dataProvider.botDrivenRegionsResource.value',
            'dataProvider.locationStateBoundariesResource.value',
            'dataProvider.locationStateRegionsResource.value',
          ], () => {
            initViewModel();
          }, true);
        }

        function initViewModel() {
          $scope.subregions = angular.copy($scope.dataProvider.locationStateRegionsResource.value);
          $scope.roomBoundaries = angular.copy($scope.dataProvider.locationStateBoundariesResource.value);

          $scope.editable = !!$scope.dataProvider.botDrivenRegionsResource.value && $scope.dataProvider.deviceResource.value?.connected;
        }

        /**
         * Get specific context from the Radar subregion behaviors.
         * @param {number} contextId
         * @param {string} contextType any context key | 'goal'
         * @returns {any} Boolean returned for context 'goal'
         */
        function getSubregionContext(contextId, contextType) {
          let subregionBehaviors = angular.copy($scope.dataProvider.locationStateRegionBehaviorsResource.value);
          let context = subregionBehaviors.find((el) => el['context_id'] === contextId);

          if (!context || !contextType) {
            return;
          }

          // Validate current device goal (return boolean)
          if (contextType === 'goal' && context['compatible_behaviors'] && context['compatible_behaviors'].length) {
            let goalId = angular.copy($scope.dataProvider.deviceResource.value?.goalId);
            return !isNaN(goalId) && context['compatible_behaviors'].some((g) => g === goalId);
            // Return context value
          } else {
            if (context[contextType]) {
              return context[contextType];
            }
          }

          return undefined;
        }

        function onAddButtonClick() {
          // TODO create empty subregion
          $scope.dataProvider.activeTab = 'radar';
        }

        function editSubregion(subregion) {
          $scope.dataProvider.subregionToEdit = angular.copy(subregion);
          $scope.dataProvider.activeTab = 'radar';
        }

        function selectSubregion(subregion) {
          $scope.dataProvider.subregionToEdit = angular.copy(subregion);
        }

        function removeSubregion(subregion) {
          $('#remove-subregion-dialog')
            .modal({
              closable: true,
              detachable: true,
              onApprove: function() {
                let subregionId = subregion['unique_id'];
                let subregionName = subregion['name'] || getSubregionContext(subregion['context_id'], 'title');

                return $scope.dataProvider.deleteRadarSubregion({
                  'unique_id': subregionId
                })
                  .then(() => {
                    ToastsService.success($t('regions.subregion.removeSuccess', { name: subregionName }));
                  }, (err) => {
                    utils.handleApiError(err);
                  });
              }
            }).modal('show');
        }

        function gotoRoomBoundaries() {
          $scope.dataProvider.activeTab = 'boundaries';
        }

      }
    };
  })
  .name;
